import {useContext, useEffect, useState} from 'react';
import {requestWrapper} from "./../components/util/helper"
import {profileConstants} from "../components/util/appConstants2";
import {
    fetchProducts,
    fetchProfile,
    getDomainOrgs,
    getUserAllowedApplications,
    savePassword, savePasswordOKta,
    saveProfileApi
} from "../api/profile-api";
import {getConfigData} from "../api/common-api";
import {getTargetUrl, isOKta, logout, trackCtaEvent} from "../utils/Utils";
import {profileConstants as profileConstants2} from "../components/util/profileConstants2";
import AppContext from "../context/AppContext";
// import authService from '../services/authService'

// Session storage keys
const PROFILE_CACHE_KEY = 'QID_PROFILE_DATA';
const PROFILE_CACHE_TIMESTAMP_KEY = 'QID_PROFILE_DATA_TIMESTAMP';
const CACHE_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds


const useProfile = (type) => {
        const {auth} = useContext(AppContext);
        const [dropDownsData, setDropDownData] = useState({
            countries: [],
            jobFunctions: [],
            deactivateReasons: [],
            countryStateMap: [],
            oktaAppIdGroups: [],
            domainOrgs: []
        })
        const [disableEdit, setDisableEdit] = useState(false);//shared variable for all the sections
        const [userData, setUserData] = useState();
        const [isLoading, setIsLoading] = useState(true);
        const [apiErrorMessages, setApiErrorMessages] = useState({});
        const [isProfileFailedToLoad, setIsProfileFailedToLoad] = useState(false);

        // Helper function to get cached profile data
        const getCachedProfileData = () => {
            try {
                const cachedData = sessionStorage.getItem(PROFILE_CACHE_KEY);
                const cachedTimestamp = sessionStorage.getItem(PROFILE_CACHE_TIMESTAMP_KEY);
                
                if (cachedData && cachedTimestamp) {
                    const timestamp = parseInt(cachedTimestamp, 10);
                    const now = Date.now();
                    
                    // Check if cache is still valid
                    if (now - timestamp < CACHE_DURATION) {
                        console.log('Using cached profile data');
                        return JSON.parse(cachedData);
                    } else {
                        console.log('Cache expired, will fetch fresh data');
                        // Clear expired cache
                        sessionStorage.removeItem(PROFILE_CACHE_KEY);
                        sessionStorage.removeItem(PROFILE_CACHE_TIMESTAMP_KEY);
                    }
                }
            } catch (error) {
                console.error('Error reading cached profile data:', error);
                // Clear corrupted cache
                sessionStorage.removeItem(PROFILE_CACHE_KEY);
                sessionStorage.removeItem(PROFILE_CACHE_TIMESTAMP_KEY);
            }
            return null;
        };

        // Helper function to cache profile data
        const setCachedProfileData = (data) => {
            try {
                sessionStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify(data));
                sessionStorage.setItem(PROFILE_CACHE_TIMESTAMP_KEY, Date.now().toString());
                console.log('Profile data cached successfully');
            } catch (error) {
                console.error('Error caching profile data:', error);
            }
        };

        // Helper function to clear cached profile data
        const clearCachedProfileData = () => {
            sessionStorage.removeItem(PROFILE_CACHE_KEY);
            sessionStorage.removeItem(PROFILE_CACHE_TIMESTAMP_KEY);
            console.log('Profile cache cleared');
        };

        const saveData = async (data, profileSection) => {
            const res = await requestWrapper(async () => {
                                try {
                    trackCtaEvent('/www-profile', profileSection)
                    let result = await saveProfileApi(data);
                    // trackFormEvent('form submit', profileSection, 'Save', 'Profile')
                    if (checkLogout(data, profileSection)) {
                        clearCachedProfileData(); // Clear cache on logout
                        logout(getTargetUrl())
                    } else {
                        result = await refreshProfileData();
                        return result;
                    }
                } catch (e) {
                    const errorMessage = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : profileConstants.SYSTEM_ERROR;
                    // trackFormEvent('form submit error', 'EmailAndPasswordInfo', errorMessage)
                    return {isError: true, errorMsg: [errorMessage]}
                }

            }, setIsLoading)();

            return res;
        };
        const savePasswordApi = async (data, section) => {

            const resp = await requestWrapper(async () => {
                try {
                    const resp = isOKta()? await  savePasswordOKta(data): await savePassword(data);
                    if (resp.status === 200) {
                        logout(getTargetUrl())
                    }
                } catch (e) {
                    const errorMessage = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : profileConstants.SYSTEM_ERROR;
                    // setApiErrorMessages({[profileConstants.PASSWORD_INFO]: [errorMessage]})
                    return {isError: true, errorMsg: [errorMessage]}
                }

            }, setIsLoading)();
            return resp;
        };
                const refreshProfileData = async () => {
            // Clear cache when explicitly refreshing
            clearCachedProfileData();
            
            const resp = await fetchProfile();
            const appDetails = userData.appDetails;
            const user = resp && resp.data;
            if (user) {
                user.appDetails = appDetails;
            }
            setUserData(user);
            auth.setActingUser(user);
            
            // Cache the refreshed data
            setCachedProfileData(user);
            
            return resp
        };
        const checkLogout = (data, section) => {
            if (section === profileConstants2.COMPANY_INFO_SECTION_ADOBE_KEY) {
                if(isOKta()){
                    return (data.orgExportId && userData.org && userData.org.orgId && data.orgExportId.toString() !== userData.org.orgId.toString())
                }else {
                    return (data.orgExportId && userData.orgExportId && data.orgExportId.toString() !== userData.orgExportId.toString())
                }
            }
            return section === profileConstants2.PASSWORD_INFO_SECTION_ADOBE_KEY

        };


        const processConfigData = (configData) => {
            if (configData) {
                let {countries, jobFunctions, deactivateReasons, countryStateMap, oktaAppIdGroups} = configData;

                jobFunctions = jobFunctions ? jobFunctions.map((val, index) => ({id: index, value: val, label: val})) : [];
                jobFunctions.unshift({id: 'selectOne', value: '', label: 'Select One'});

                countries = countries ? countries.map((country) => ({
                    id: country.code,
                    value: country.code,
                    label: country.name
                })) : [];

                countryStateMap = countryStateMap ? countryStateMap.map((countryState) => ({
                    id: countryState.code,
                    label: countryState.name,
                    value: countryState.code,
                    states: getStates(countryState)
                })) : [];


                deactivateReasons = deactivateReasons ? deactivateReasons.map(r => ({
                    id: r.id,
                    value: r.description,
                    label: r.description
                })) : [];
                deactivateReasons.unshift({id: 0, value: '', label: 'Select One'});

                return {countries, jobFunctions, deactivateReasons, countryStateMap, oktaAppIdGroups: oktaAppIdGroups || []}
            }
            // Return default structure if configData is null/undefined
            return {
                countries: [],
                jobFunctions: [{id: 'selectOne', value: '', label: 'Select One'}],
                deactivateReasons: [{id: 0, value: '', label: 'Select One'}],
                countryStateMap: [],
                oktaAppIdGroups: []
            };
        };

        const getStates = (countryState) => {
            let states = countryState.states.map((state) => ({
                id: state.code,
                label: state.name,
                value: state.code
            }));

            if (states != null && states.length > 0) {
                states.unshift({
                    id: 'selectOne',
                    value: '',
                    label: 'Select One'
                });
            }

            return states;
        }
        // const getCookieValue = (name) => {
        //     return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
        // }
        const fetchUserProducts = async () => {
            const resp = await fetchProducts();
            return resp.data
        };
                useEffect(() => {
            const loadProfileData = async () => {
                return await requestWrapper(async () => {
                    try {
                        // Check if we have cached profile data
                        const cachedProfile = getCachedProfileData();
                        
                        if (cachedProfile) {
                            // Use cached data
                            console.log('✅ Loading profile from session cache');
                            console.log('📡 Fetching dropdown data from API (not cached)');
                            
                            // Fetch dropdown data first before setting userData to avoid race condition
                            const data = await Promise.all([
                                getDomainOrgs(),
                                getConfigData('jobFunctions, countries,deactivateReasons,countryStateMap, oktaAppIdGroups')
                            ]);
                            
                            console.log('✅ Dropdown data fetched successfully');
                            const domainOrgs = (data.length > 0 && data[0]) ? data[0].sort((a, b) => a.label.localeCompare(b.label)) : [];
                            const configData = (data.length > 1 && data[1]) ? data[1] : [];
                            const dropDownsData = {...(processConfigData(configData)), domainOrgs};
                            setDropDownData(dropDownsData);
                            
                            // Now set userData after dropDownsData is ready
                            setUserData(cachedProfile);
                            auth.setActingUser(cachedProfile);
                            console.log('✅ Profile loaded from cache with fresh dropdown data');
                        } else {
                            // Fetch fresh data
                            console.log('📡 No cache found - Fetching fresh profile data from API');
                            const data = await Promise.all([
                                fetchProfile(), getDomainOrgs(), getUserAllowedApplications(),
                                getConfigData('jobFunctions, countries,deactivateReasons,countryStateMap, oktaAppIdGroups'), fetchUserProducts()
                            ]);


                            const profileData = (data.length > 0 && data[0]) ? data[0].data : {};
                            const domainOrgs = (data.length > 1 && data[1]) ? data[1].sort((a, b) => a.label.localeCompare(b.label)) : [];
                            const appDetails = (data.length > 2 && data[2]) ? data[2].data.appDetails : [];
                            const configData = (data.length > 3 && data[3]) ? data[3] : [];
                            const products = (data.length > 4 && data[4]) ? data[4] : [];
                            profileData.appDetails = appDetails;
                            profileData.products = products;
                            const dropDownsData = {...(processConfigData(configData)), domainOrgs};
                            if(isOKta()){
                                // const oktaJwtClaims = authService.readOktaJwt()
                                // const {groups:appIds} =  oktaJwtClaims
                                const  appIds = (data.length > 0 && data[0] && data[0].data && data[0].data.allMemberShips) ? data[0].data.allMemberShips : {};
                                if(appIds && appIds.length){
                                    const {oktaAppIdGroups:oktaAppIdGroupsFromConfig} =dropDownsData

                                    const matchedAppIds =  oktaAppIdGroupsFromConfig.filter(obj=>!!(appIds.find(appid=>appid.toLowerCase()===obj.id.toLowerCase())) )
                                    console.log({matchedAppIds})

                                    profileData.appDetails =matchedAppIds
                                }

                            }


                            setDropDownData(dropDownsData);
                            setUserData(profileData);
                            auth.setActingUser(profileData);
                            
                            // Cache the profile data
                            setCachedProfileData(profileData);
                            console.log('✅ Fresh profile data fetched and cached successfully');
                        }
                    } catch (e) {
                        const errorMessage = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : profileConstants.SYSTEM_ERROR
                        setApiErrorMessages({common: [errorMessage]});
                        setIsProfileFailedToLoad(true)
                    }
                }, setIsLoading)()
            };
            try {
                loadProfileData()
            } catch (e) {

            }

            // eslint-disable-next-line
        }, []);


        const exports = {
            userData,
            dropDownsData,
            saveData,
            savePasswordApi,

                        disableEdit,
            setDisableEdit,

            isLoading,
            isProfileFailedToLoad,
            apiErrorMessages,
            setApiErrorMessages,
            
            // Expose cache management functions
            clearCachedProfileData,
            refreshProfileData
        };

        return {
            ...exports
        };
    }
;

export default useProfile;